function _object_without_properties(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
import { registerValidateMessageTemplateEngine } from "@formily/core";
export function registerValidateMessageTemplates(templates) {
  registerValidateMessageTemplateEngine((message, context) => {
    const { field, form, value } = context, rules = _object_without_properties(context, [
      "field",
      "form",
      "value"
    ]);
    for (const template of templates) {
      const { keys, engine } = template;
      if (keys.find((k) => Object.hasOwn(rules, k))) {
        return engine({
          field,
          value,
          message,
          rules,
          form
        });
      }
    }
    return message;
  });
}
